"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuSplitGroup", {
    enumerable: true,
    get: function() {
        return MenuSplitGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuSplitGroup = require("./useMenuSplitGroup");
const _renderMenuSplitGroup = require("./renderMenuSplitGroup");
const _useMenuSplitGroupStylesstyles = require("./useMenuSplitGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuSplitGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuSplitGroup.useMenuSplitGroup_unstable)(props, ref);
    (0, _useMenuSplitGroupStylesstyles.useMenuSplitGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuSplitGroupStyles_unstable')(state);
    return (0, _renderMenuSplitGroup.renderMenuSplitGroup_unstable)(state);
});
MenuSplitGroup.displayName = 'MenuSplitGroup';
